const parseAnswers = (collectedAnswers) => {
    try {
        const raw = typeof collectedAnswers === "string"
            ? JSON.parse(collectedAnswers || "[]")
            : (collectedAnswers ?? []);
        return Array.isArray(raw) ? raw : [];
    } catch {
        return [];
    }
};

const parseList = (value) => {
    try {
        const list = typeof value === "string" ? JSON.parse(value) : value;
        return Array.isArray(list) ? list : [];
    } catch {
        return [];
    }
};

export const extractConversationFlags = (interactions) => {
    const unanswered = [];
    const humanTopics = [];

    (interactions ?? []).forEach((interaction) => {
        parseAnswers(interaction.collectedAnswers).forEach((a) => {
            if (a.name === "@unanswered_questions") unanswered.push(...parseList(a.value));
            if (a.name === "@human_topics") humanTopics.push(...parseList(a.value));
        });
    });

    return {
        unanswered: unanswered.filter(q => q?.question),
        humanTopics: humanTopics
            .filter(h => h?.topic)
            .sort((a, b) => (a.priority === "high" ? 0 : 1) - (b.priority === "high" ? 0 : 1)),
    };
};
